import React from 'react'
import {OnboardingOverlay} from 'common/OnboardingOverlay'
import {TwoCTAFooter} from 'common/styleguide/Modal'
import {CTA} from 'common/styleguide/CTA'
import circleHome from './circleHome.svg'
import {DASH_LAUNCH} from 'lib/utils'

export const DashboardOnboardingOverlay = ({currentUser, ...props}) => {
  // "legacy user" in this context referrs to a user who was previously used to
  // seeing the Classic Profile page as their home page for the site.
  // legacy users see a slightly different set of onboarding steps that helps
  // explain the homepage in the context of a redesign of an existing feature,
  // as opposed to the content we show when onboarding a brand-new user
  const legacyUser = currentUser.createdAt < DASH_LAUNCH

  const introStep = {
    heading: <span>Welcome to your {legacyUser && 'new '}Ride with GPS homepage</span>,
    content: <div>
      <img src={circleHome} height='100' width='100' style={{marginBottom: '30px', marginTop: '20px'}} />
      {legacyUser
        ? <p>With the new homepage, it's easier to access <br />the data and features you use most</p>
        : <p>This is your hub for everything Ride with GPS. Let's take a quick
        1-minute tour to get you acquainted with the most important features.</p>}
    </div>,
    footer: next => <TwoCTAFooter>
      <a onClick={props.onRequestClose}>Skip</a>
      <CTA inline margins={false} onClick={next}>
        Show Me Around
      </CTA>
    </TwoCTAFooter>
  }

  const onboardingSteps = [
    {
      heading: 'The Ride with GPS Dashboard: your quick access hub',
      content: <p>Access all your most important data and stats with one click.</p>,
      targetId: 'dashboard-nav-home'
    },
    {
      heading: 'Your routes, rides, and more',
      content: <p>Click to quickly access your calendar, routes, and rides, or to upload your files.</p>,
      targetId: 'side-nav-links'
    },
    {
      heading: 'Analyze your rides',
      content: <p>The Ride Center provides powerful tools to analyze your rides and manage your ride data in bulk.</p>,
      targetId: 'dashboard-nav-analyze'
    },
    {
      heading: `Connect with friends and see what they're up to`,
      content: <p>See your friends list and what your friends are riding or planning.</p>,
      targetId: 'dashboard-nav-friends'
    },
    {
      heading: 'Access your photos, segments, and profile',
      content: <p>All of your account details, photos, segments, gear, and profile info now live in one place.</p>,
      targetId: 'dashboard-nav-more'
    },
    legacyUser && {
      heading: 'Return to the Ride with GPS classic profile any time',
      content: <p>You can return to the classic profile by clicking the highlighted link.</p>,
      targetId: 'dashboard-nav-classic-profile'
    },
    {
      heading: 'Send feedback to our support team at any time',
      // TODO - update this once https://github.com/ridewithgps/ridewithgps/issues/6665
      // is completed
      content: <p>Have questions or comments about the new homepage?
      Get in touch with Ride with GPS support via our Help portal, or by clicking
      the blue help button.</p>,
      targetId: 'global-nav-help'
    }
  ].filter(v => v)

  return <OnboardingOverlay
    {...props}
    introStep={introStep}
    steps={onboardingSteps} />
}
